import React from 'react';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import Draggable from 'react-draggable';
import { withStyles } from '@material-ui/core/styles';
import {
    IconButton,
    List, ListItem, ListItemText, ListItemSecondaryAction,
    Toolbar, TextareaAutosize
} from '@material-ui/core';
import {
    Delete as DeleteIcon,
    Reorder as ReorderIcon,
    GpsFixed as LocationIcon,
    Visibility as VisibilityIcon,
    VisibilityOff as VisibilityOffIcon,
    GetApp as DownloadIcon
} from '@material-ui/icons';

import Save from '../Admin/Save';

const styles = theme => ({
    container: {
        overflow: 'auto',
        maxHeight: 300,
    },
    blue: {
        fill: theme.palette.primary[700],
    },
    button: {
        //fontSize:'1rem',
        //height:'auto',
    },
    toolbar: {
        minHeight: 'auto',
    },
    enabled: {
        //color:'#333'
    },
    disabled: {
        opacity: 0.5,
    },
    callToAction: {
        minHeight: '100px',
        color:'#e0e0e0',
        lineHeight:'200px',
        textAlign:'center',
    }
});

// TODO: figure out a better way to do this - seperate files or cleanup?

const DragHandle = SortableHandle((classes) => <IconButton aria-label="Reorder" className={classes.button + " reorderBtn"}>
    <ReorderIcon />
</IconButton>);
const SortableItem = SortableElement(({ item, classes, handleToggle, handleStyle, styleChange, handleDelete, handleSave, handleFlyTo, isDocked }) =>
    <ListItem dense divider disableGutters className={item.Visible ? classes.enabled : classes.disabled}>
        <IconButton aria-label="Toggle" onClick={handleToggle.bind(this, item.Id, item.Visible)} className={classes.button}>
            {item.Visible ? <VisibilityIcon className={classes.blue} /> : <VisibilityOffIcon />}
        </IconButton>
        <ListItemText primary={item.Name} style={isDocked?{maxWidth:'200px'}:null}/>
        <Toolbar disableGutters className={classes.toolbar}>
            {item.Visible &&
                <>
                <TextareaAutosize aria-label="StyleText" value={item.style} onChange={styleChange.bind(this,item.Id)} rowsMin={5} rowsMax={5} />
                <IconButton aria-label="StyleLayer" className={classes.button} onClick={handleStyle.bind(this, item.Id)}>
                    <LocationIcon />
                </IconButton>
                <Save filename={item.Filename} isSaved={!item.Changed} onSaveAs={handleSave.bind(this, item.Id)} onSave={handleSave.bind(this, item.Id, item.Filename)}  /> 
                {/*<IconButton aria-label="Save" className={classes.button} onClick={handleSave.bind(this, item.Id)}>
                    <DownloadIcon />
                </IconButton>*/}
                </>
            }            
            {
                <IconButton aria-label="Delete" className={classes.button} onClick={handleDelete.bind(this, item.Id)}>
                    <DeleteIcon />
                </IconButton>
            }
            <DragHandle classes={classes} />
        </Toolbar>
    </ListItem>
);
const SortableList = SortableContainer(({ items, classes, layerItems, handleToggle, handleDelete, handleFlyTo, handleStyle, styleChange, handleSave, isDocked }) => {
    // Update Prediction Layers with Display Property
    let updatedLayers = items.map(layer=>{
        layer.Display = true;
        return layer;
    })
    items = updatedLayers;
    return (
        <List dense disablePadding className={classes.container}>
            {items.map((value, index) => (
                (value.Display)&&<SortableItem key={`item-${index}`} index={index} isDocked={isDocked} item={value} classes={classes} styleChange={styleChange} handleSave={handleSave} handleStyle={handleStyle} handleFlyTo={handleFlyTo} handleDelete={handleDelete} handleToggle={handleToggle} />
            ))}
        </List>
    );
});

class LayerList extends React.Component {
    constructor(props) {
        super(props);
        this.state = { visLayers: [] };
    }
    handleToggle(id, isInputChecked, item, evt) {
        if (this.props.handleToggle)
            this.props.handleToggle(id, !isInputChecked);
    }
    componentDidMount() {
        this.setState({ visLayers: this.props.visLayers });
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ visLayers: nextProps.visLayers });
    }
    handleFlyTo(id,evt) {
        if (this.props.handleFlyTo)
            this.props.handleFlyTo(id);
    }
    handleDelete(id,evt) {
        if(this.props.handleDelete)
            this.props.handleDelete(id);
    }
    handleStyle(id,evt) {
        var vis = this.state.visLayers.find(x => x.Id === id);
        if(this.props.handleStyle)
            this.props.handleStyle(id,vis.style);
    }
    handleSave(id,filename,evt) {      
        if(this.props.handleSave)
            this.props.handleSave(id,filename);
        this.setState(state => {
            const visLayers = state.visLayers.map((item) => {
                if (item.Id === id) {
                    item.Changed = false;
                    item.Filename = filename;
                } 
                return item;
            });
    
            return {
                visLayers,
            };
        });
    }
    styleChange(id, evt) {
        evt.persist();
        var vis = this.state.visLayers.find(x => x.Id === id);
        var style = vis.style;
        vis.style = evt.target.value;
        if (style != vis.style) {
            this.setState(state => {
                const visLayers = state.visLayers.map((item) => {
                    if (item.Id === id) {
                        item.Changed = true;
                        item.style = vis.style;
                    } 
                    return item;
                });
                return {
                    visLayers,
                };
            });
        }
    }
    onSortEnd({oldIndex, newIndex}) {
        // this.setState({
        //     visLayers: arrayMove(this.state.visLayers, oldIndex, newIndex),
        // });
        // let newOrder = this.state.visLayers
        if(this.props.handleSorted)
             this.props.handleSorted(oldIndex,newIndex);
    }
    render() {
        let items = this.state.visLayers;// && this.state.visLayers.sort(x => x.order);
        let layerItems = null;
        if (items.length == 0)
            return <div className={this.props.classes.callToAction}>No visualisations to display</div>;
        return (
            <SortableList 
                onSortEnd={this.onSortEnd.bind(this)} 
                useDragHandle={true} 
                items={items} 
                classes={this.props.classes}
                handleFlyTo={this.handleFlyTo.bind(this)} 
                handleDelete={this.handleDelete.bind(this)} 
                handleToggle={this.handleToggle.bind(this)} 
                handleStyle={this.handleStyle.bind(this)}
                styleChange={this.styleChange.bind(this)}
                handleSave={this.handleSave.bind(this)}
                hideSortableGhost={true}
                isDocked={this.props.isDocked}
            />
        )
    }
}

export default withStyles(styles)(LayerList)